import { formatDistanceToNow, format, parseISO, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatDate(date: string | Date): string {
  try {
    const d = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(d)) {
      console.warn('Invalid date:', date);
      return 'Data inválida';
    }
    return format(d, 'dd/MM/yyyy', { locale: ptBR });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Data inválida';
  }
}

export function formatRelativeTime(date: string | Date): string {
  try {
    const d = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(d)) {
      console.warn('Invalid date:', date);
      return 'Data inválida';
    }
    return formatDistanceToNow(d, { addSuffix: true, locale: ptBR });
  } catch (error) {
    console.error('Error formatting relative time:', error);
    return 'Data inválida';
  }
}